import ResetPassword from "@auth/pages/reset-password";
import { createFileRoute } from "@tanstack/react-router";

interface QueryString {
  redirect: string;
}

export const Route = createFileRoute(
  "/(auth)/(headless)/(distributor)/reset-password"
)({
  component: () => <ResetPassword />,
  validateSearch: (search: Record<string, unknown>): QueryString => {
    const typedSearch = {} as QueryString;

    if (search.redirect) {
      typedSearch.redirect = search.redirect as string;
    }

    return typedSearch;
  },
});
